import { coursePages } from '../constants';

const isCoursePage = (pathname: string) => coursePages.some((page) => pathname.startsWith('/' + page.root));

export default isCoursePage;
